import React from "react";
import { useNavigate } from "react-router-dom";
import { useState } from "react";

const Home = () => {
    const navigate = useNavigate();
    const [activeItem, setActiveItem] = useState(""); // To track active item
    const handleNavigation = (sectionId) => {
        setActiveItem(sectionId);  // Mark the item as active
        navigate('/overviewofcourse', { state: { sectionId } });
        console.log("section_id", sectionId)
    };
    return (
        <div className="container-fluid px-1">
            <div className="row justify-content-center">
                <div className="text-center">
                    <img
                        src="https://57lms.s3.us-east-1.amazonaws.com/welcome+page.png"
                        alt="Home_img"
                        className="img-fluid rounded shadow-lg"
                    />
                </div>
            </div>

            <div className="row justify-content-center mt-4">
                <div className="col-md-11 text-center">
                    <h4 className="fw-bold">Welcome to 57 Peace Protection Pte Ltd Online Learning Platform!</h4>
                    <p className="lead">We are excited to have you on board.</p>
                </div>
            </div>

            <div className="row justify-content-center mt-3">
                <div className="col-md-11">
                    <p className="justify-contend-end text-muted" style={{ textAlign: 'justify' }}>
                        This is an exclusive e-learning platform designed for officers at 57 Peace Protection Pte Ltd.
                        Here, you can enhance your skills, knowledge and expertise in the security industry through
                        structured lessons, quizzes and interactive activities—all at your own pace.
                    </p>
                </div>
            </div>

            <div className="row justify-content-center mt-4">
                <div className="col-md-11">
                    <h5 className="fw-semibold">Getting Started</h5>
                    <p className="text-muted" style={{ textAlign: 'justify' }}>
                        As part of your professional development, you have been enrolled in courses by the company.
                        These courses are specially designed to equip you with the necessary skills to excel in your role
                        and meet industry standards.
                    </p>
                    <p className="text-muted" style={{ textAlign: 'justify' }}>
                        Look out for new training modules that will be added to the platform from time to time. These courses
                        are designed for our employees only and will help you stay updated with the latest security practices
                        and regulations.
                    </p>
                </div>
            </div>

            <div className="row justify-content-center mt-4">
                <div className="col-md-11">
                    <h5 className="fw-semibold">How to Navigate the Platform</h5>
                    <p className="text-muted">If you are new to the system, start by exploring the website.</p>
                    <h6 className="fw-semibold">👉 Not sure where to begin?</h6>
                    <ul className="list-group list-group-flush">
                        <li className="list-group-item">Click on <a href="#" onClick={(e) => { e.preventDefault();  handleNavigation('4');}}>CPD Security Training</a> in the main menu.</li>
                        <li className="list-group-item">Select <a href="#" onClick={(e) => { e.preventDefault();  handleNavigation('4');}}>Overview of Course</a> to see the training modules assigned to you.</li>
                        <li className="list-group-item">Start learning by watching training videos, reading materials and completing activities.</li>
                        <li className="list-group-item">Some courses may require you to complete an <strong>E-assessment</strong> to test your understanding.</li>
                    </ul>
                </div>
            </div>

            <div className="row justify-content-center mt-4">
                <div className="col-md-11">
                    <h5 className="fw-semibold">📌 Menu Guide</h5>
                    <ul className="list-group list-group-flush">
                        <li className="list-group-item">🔹  <a href="#" onClick={() => navigate(`/staffprofile/${localStorage.getItem("user_id")}`)}>
                            My Profile
                        </a> – Manage your personal account and settings.</li>
                        <li className="list-group-item">🔹 <a href="#" onClick={(e) => { e.preventDefault();  handleNavigation('4');}}>CPD Security Training</a> – Access all security training courses.</li>
                        <li className="list-group-item">🔸 <a href="#" onClick={(e) => { e.preventDefault();  handleNavigation('4');}}>Overview of Course</a> – View the list of courses assigned to you.</li>
                    </ul>
                </div>
            </div>

            <div className="row justify-content-center mt-4">
                <div className="col-md-11">
                    <h5 className="fw-semibold">Commitment to Excellence</h5>
                    <p className="text-muted" style={{ textAlign: 'justify' }}>
                        At 57 Peace Protection Pte Ltd, we believe that continuous learning is key to delivering top-quality security services.
                        This platform is designed to help you grow, improve and succeed in your role.
                    </p>
                </div>
            </div>

            <div className="row justify-content-center mt-4">
                <div className="col-md-11 text-center">
                    <h5 className="fw-bold">🚀 Let’s Strive for Excellence! 🚀</h5>
                </div>
            </div>
        </div>
    );
};

export default Home;
